import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../../components/Text'

const Box = styled.div`
  color: var(--${props => props.color});
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  & > h1 {
    font-weight: 500;
    font-size: 1.5rem;
    padding: 0 1rem 0.75rem 1rem;
    border-bottom: 1px solid var(--light-gray);
  }
  
  @media print {
    margin-bottom: 0;
    & > h1 {
      font-size: 1rem;
    }
  }
`

export default class SectionHeader extends Component {
  render() {
    const { str, ...props } = this.props

    return (
      <Box {...props}>
        <h1><Text str={str} /></h1>
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Print/Header.js